<script setup lang="ts">
import { highlightString } from '@corp/services/highlight'

const { size = 'large', labelProp = '', descriptionProp = '' } = defineProps<{
  // The label of the option.
  item?: any

  // The label property to use for the option.
  labelProp?: string

  // The description property to use for the option.
  descriptionProp?: string

  // The string filtering all options. Used for highlighting.
  filteringBy?: string

  // The size of the input.
  size?: 'small' | 'large'
}>()

const itemVariant = {
  small: 'p-3 text-xs',
  large: 'px-4 py-3',
}

</script>

<template>
  <div
    class="select-item cursor-pointer flex gap-2 items-center font-medium"
    :class="[itemVariant[size], { italic: item?.unselect }]"
  >
    <slot name="pre"/>
    <slot name="label">
      <template v-if="item.creatable">
        <span>Add <label>{{ item?.[labelProp] }}</label>…</span>
      </template>

      <template v-else>
        <template v-if="item.unselect">
          {{ item?.[labelProp] }}
        </template>

        <template v-else>
          <template v-if="filteringBy">
            <label>
              <component
                :is="part"
                v-for="part in highlightString(item?.[labelProp], { query: filteringBy })"
                :key="part.key"
              />
            </label>
          </template>

          <template v-else>
            <label>{{ item?.[labelProp] }}</label>
          </template>
        </template>
      </template>

      <div v-if="item?.[descriptionProp]" :class="size === 'large' ? 'text-xs' : 'text-2xs'">
        {{ item?.[descriptionProp] }}
      </div>
    </slot>
    <slot name="post"/>
  </div>
</template>

<style lang="scss" scoped>
.select-item {
  &.focused {
    @apply text-navy bg-surface-grey;
  }

  :deep(label) {
    cursor: inherit;
  }
}

:deep(.highlighted) {
  @apply text-v2-active;
}
</style>
